import React, { useEffect, useState } from "react";
import { Box, IconButton, Typography, Grid, Stack } from "@mui/material";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import { motion, AnimatePresence } from "framer-motion";
import SchoolIcon from "@mui/icons-material/School"; // Experienced Instructors
import PeopleIcon from "@mui/icons-material/People"; // 1:1 Doubt Clearing
import WorkIcon from "@mui/icons-material/Work"; // Students Got Placed
import TrendingUpIcon from "@mui/icons-material/TrendingUp"; // Salary Hike

const testimonials = [
  "51% of learners received 45% and above salary hike post completion of the program*",
  "85% of students found the course content highly relevant to their career growth*",
  "70% of students secured a job within 6 months of course completion*",
];

const fixedIcons = [
  { icon: <SchoolIcon sx={{ color: "green" }} />, text: "Experienced Instructors" },
  { icon: <PeopleIcon sx={{ color: "blue" }} />, text: "1:1 Doubt Clearing Session" },
  { icon: <WorkIcon sx={{ color: "orange" }} />, text: "7000+ Students Got Placed" },
  { icon: <TrendingUpIcon sx={{ color: "blue" }} />, text: "65% Avg. Salary Hike" },
];

const TestimonialsCarousel = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const prevSlide = () => {
    setIndex((prevIndex) => (prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1));
  };

  const nextSlide = () => {
    setIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
  };

  return (
    <Box
      sx={{
        background: "linear-gradient(to right, #e0c3fc, #8ec5fc)",
        borderRadius: 3,
        p: 3,
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        mx: "auto",
        my: 5,
        position: "relative",
      }}
    >
      {/* Left Arrow */}
      <IconButton onClick={prevSlide} sx={{ position: "absolute", left: 10, top: "20%" }}>
        <ArrowBackIos />
      </IconButton>

      {/* Scrolling Text with Icon */}
      <AnimatePresence mode="wait">
        <motion.div
          key={index}
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -50 }}
          transition={{ duration: 0.5 }}
        >
          <Stack direction="row" alignItems="center" spacing={1}>
            <TrendingUpIcon sx={{ color: "purple" }} />
            <Typography variant="h6" fontWeight="bold">
              {testimonials[index]}
            </Typography>
          </Stack>
        </motion.div>
      </AnimatePresence>

      {/* Fixed Icons with Text */}
      <Grid container spacing={2} justifyContent="center" sx={{ mt: 2 }}>
        {fixedIcons.map((item, i) => (
          <Grid item key={i} xs={6} sm={3} textAlign="left">
            <Stack direction="row" alignItems="center" spacing={1}>
              {item.icon}
              <Typography variant="body2" fontWeight="bold">
                {item.text}
              </Typography>
            </Stack>
          </Grid>
        ))}
      </Grid>

      {/* Right Arrow */}
      <IconButton onClick={nextSlide} sx={{ position: "absolute", right: 10, top: "20%" }}>
        <ArrowForwardIos />
      </IconButton>
    </Box>
  );
};

export default TestimonialsCarousel;
